import TasksAccordion from './layouts/TasksAccordion'
import TasksList from './layouts/TasksList'

export const LAYOUTS = {
  tasksAccordion: TasksAccordion,
  tasksList: TasksList
}

export const DEFAULT_LAYOUT = 'tasksAccordion'
